<template>
    <filters-and-pagination
        :pagination-data="filterAndPaginationStore.leadsFiltersAndPaginationData"
        :filterable-fields="filterFields"
        :loading-data="filterAndPaginationStore.loadingFiltersAndPaginationData"
    >
        <leads-data-table :leads="filterAndPaginationStore.leadsFiltersAndPaginationData.data" />
    </filters-and-pagination>
</template>

<script setup>
import FiltersAndPagination from "../filters-and-pagination/FiltersAndPagination";
import LeadsDataTable from "./components/LeadsDataTable.vue";
import { usePortalFilterAndPaginationStore } from "../../../stores/partners/filterAndPagination";

const props = defineProps({
    filterFields: {
        type: Object
    },
    partnerProgramActivitiesUrl: {
        type: String
    }
});

const filterAndPaginationStore = usePortalFilterAndPaginationStore();
</script>
